import axios from "axios";
import { useEffect, useState } from "react";
import { saveMember, getMember } from "@/services/demoMember";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const startStripeSignup = async (member) => {
  const { data } = await axios.post(`${API}/signups`, {
    country: member.country,
    city: member.city,
    dream: member.dream || "",
    email: member.email,
    civility: member.civility,
    first_name: member.firstName,
    last_name: member.lastName,
    method: "email",
    promo_opt_in: !!member.promoOptIn,
    previous_id: member.signupId || null,
  });
  saveMember({ signupId: data.id });
  window.location.assign(data.checkout_url);
};

export const resolveSession = async (sessionId) => (await axios.get(`${API}/signups/by-session/${sessionId}`)).data.id;

export const getSignupStatus = async (id, sessionId) =>
  (await axios.get(`${API}/signups/${id}`, { params: sessionId ? { session_id: sessionId } : {} })).data;

export const requestAccountLink = async (email) => (await axios.post(`${API}/account/link`, { email })).data;

export const getAccount = async (t) => (await axios.get(`${API}/account`, { params: { t } })).data;

export const STATUS_LABELS = {
  pending_payment: "Inscription non finalisée",
  processing: "Confirmation en cours de réception",
  trial: "Essai gratuit en cours",
  trial_cancelling: "Essai en cours, résiliation programmée",
  active: "Abonnement actif",
  active_cancelling: "Abonnement actif, résiliation programmée",
  past_due: "Paiement en attente",
  cancelled: "Abonnement résilié",
};

export const isMember = (status) => ["trial", "trial_cancelling", "active", "active_cancelling"].includes(status);

// "loading" | "member" | "not_member", based on the status confirmed by Stripe.
export const useMemberAccess = () => {
  const { signupId } = getMember();
  const [access, setAccess] = useState(signupId ? "loading" : "not_member");
  useEffect(() => {
    if (!signupId) return;
    getSignupStatus(signupId)
      .then((s) => setAccess(isMember(s.status) ? "member" : "not_member"))
      .catch(() => setAccess("not_member"));
  }, [signupId]);
  return access;
};

export const frDate = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : "");
